// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Specific CSS classes for elements */
.edit-module {
  background-color: #e0a44a;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.edit-module h2 {
  margin-bottom: 20px;
}

.form-field {
  margin-bottom: 10px;
}

.form-field label {
  display: block;
}

.form-field input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.inz-dropdown{
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}


.delete-icon {
  color: #f44336;
  cursor: pointer;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .edit-module {
    padding: 10px;
  }

  .form-field input {
    padding: 6px; /* Reduce padding for smaller screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/editmodule.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY,EAAE,uCAAuC;EACvD;AACF","sourcesContent":["/* Specific CSS classes for elements */\n.edit-module {\n  background-color: #e0a44a;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.edit-module h2 {\n  margin-bottom: 20px;\n}\n\n.form-field {\n  margin-bottom: 10px;\n}\n\n.form-field label {\n  display: block;\n}\n\n.form-field input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.inz-dropdown{\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.button-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n\n.delete-icon {\n  color: #f44336;\n  cursor: pointer;\n}\n\n/* Responsive Styles */\n@media screen and (max-width: 768px) {\n  .edit-module {\n    padding: 10px;\n  }\n\n  .form-field input {\n    padding: 6px; /* Reduce padding for smaller screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
